import { useEffect } from 'react';

/**
 * Hängt strukturierte Daten (JSON-LD) einer einzelnen Seite in den `<head>`
 * und räumt sie beim Seitenwechsel wieder ab.
 *
 * Die Stammdaten des Betriebs (`LocalBusiness`) stehen statisch in
 * `public/index.html`. Hier landet nur, was von der jeweiligen Seite abhängt —
 * etwa `BlogPosting` und `BreadcrumbList` einer Beitragsseite.
 *
 * `data` sollte eine stabile Referenz sein (`useMemo`), sonst wird das Script
 * bei jedem Rendern neu geschrieben.
 */
export function useJsonLd(id: string, data: unknown | null): void {
  useEffect(() => {
    if (!data) return;

    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.dataset.jsonld = id;
    script.textContent = JSON.stringify(data);
    document.head.appendChild(script);

    return () => {
      script.remove();
    };
  }, [id, data]);
}

export default useJsonLd;
